module.exports = __webpack_public_path__ + "img/background.42cf0b73.jpg";